import React from 'react';
import { Tag, Calendar, Users, Sun, DollarSign, Compass, Star } from 'lucide-react';
import { useAnalytics } from '../../context/AnalyticsContext';
import { useCampContext } from '../../context/CampContext';

interface NoCampsFoundProps {
  onRemoveFilter: (filterType: string) => void;
  onClearAll?: () => void;
}

const NoCampsFound: React.FC<NoCampsFoundProps> = ({ onRemoveFilter, onClearAll }) => {
  const { filters, camps, visibleCamps } = useCampContext();
  const { trackEvent } = useAnalytics();

  const startDate = filters.startDate ? new Date(filters.startDate) : null;
  const isAfterMarch31 = startDate && startDate > new Date('2025-03-31');

  return (
    <div className="camp-cards-container">
      <div className="no-camps-found">
        <h2 className="no-camps-title">No Camps Found</h2>

        <p className="no-camps-description">
          {(() => {
            if (isAfterMarch31) {
              return "The last camp available at this point is on August 31st 2026. Try adjusting your date range to find more camps!";
            }
            if (visibleCamps && visibleCamps.length === 0 && camps && camps.length > 0) {
              return "It looks like there are no camps in the current map area. Try moving or zooming out the map to find more camps!";
            }
            return "It looks like your current filters are a bit too restrictive. Try adjusting them to find more camps!";
          })()}
        </p>


          {(() => {
            if (isAfterMarch31) {
              return (
                <>
                  {(filters.startDate || filters.endDate) && (
                    <button
                      className="btn btn--secondary explore-all-btn"
                      onClick={() => onRemoveFilter('dateRange')}
                    >
                      <Calendar className="icon icon--sm" />
                      Clear Date Range
                    </button>
                  )}
                </>
              );
            }

            return (
              <div className="filter-removal-buttons">
                {filters.duration && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('duration')}
                  >
                    <Sun className="icon icon--sm" />
                    Remove Full/Half Day Selection
                  </button>
                )}

                {(filters.minPrice || filters.maxPrice) && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('priceRange')}
                  >
                    <DollarSign className="icon icon--sm" />
                    Remove Price Range
                  </button>
                )}

                {filters.activityKeywords && filters.activityKeywords.length > 0 && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('activityKeywords')}
                  >
                    <Tag className="icon icon--sm" />
                    Remove Activity Keywords
                  </button>
                )}

                {(filters.startDate || filters.endDate) && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('dateRange')}
                  >
                    <Calendar className="icon icon--sm" />
                    Remove Date Range
                  </button>
                )}

                {filters.ages && filters.ages.length > 0 && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('ages')}
                  >
                    <Users className="icon icon--sm" />
                    Remove Age Group
                  </button>
                )}

                {filters.minRating && (
                  <button
                    className="filter-removal-btn"
                    onClick={() => onRemoveFilter('minRating')}
                  >
                    <Star className="icon icon--sm" />
                    Remove Rating Filter
                  </button>
                )}
              </div>
            );
          })()}


        {(
          onClearAll && (
            <button
              className="btn btn--primary explore-all-btn"
              onClick={() => {
                trackEvent('results_page_explore_all_camps_clicked');
                onClearAll();
              }}
            >
               <Compass className="icon icon--sm" />
               Explore All Camps
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default NoCampsFound;
